import axios from "../axios"

const getApplications = (params = null) => {
    return axios.get(`/applicant/applications`, { params: params })
        .then(response => response.data)
}

const getApplication = id => {
    return axios.get(`/applicant/applications/${id}`)
        .then(response => response.data)
}

const deleteApplication = id => {
    return axios.delete(`/applicant/applications/${id}/delete`)
        .then(response => response.data)
}

const sendToExpertise = id => {
    return axios.post(`/applicant/applications/${id}/send`)
        .then(response => response.data)
}

const sendRemarksToExpertise = id => {
    return axios.post(`/applicant/applications/${id}/send-remarks`)
        .then(response => response.data)
}

const sendInProcessTypeRemarksToExpertise = (applicationId, versionId, documentId) => {
    return axios.post(`/applicant/applications/${applicationId}/versions/${versionId}/documents/${documentId}/send-in-process-type-remarks`)
        .then(response => response.data)
}

const storeApplication = (credentials) => {
    return axios.post(`/applicant/applications/new`, credentials)
        .then(response => response.data)
}

const storeRepeatedApplication = (credentials) => {
    return axios.post(`/applicant/applications/repeated/new`, credentials)
        .then(response => response.data)
}

const updateApplication = (id, credentials) => {
    return axios.post(`/applicant/applications/${id}/edit`, credentials)
        .then(response => response.data)
}

const updateRepeatedApplication = (id, credentials) => {
    return axios.post(`/applicant/applications/repeated/${id}/edit`, credentials)
        .then(response => response.data)
}

const storeLocation = (id, credentials) => {
    return axios.post(`/document/location/add/${id}`, credentials)
        .then(response => response.data)
}

const updateLocation = (id, credentials) => {
    return axios.post(`/document/location/edit/${id}`, credentials)
        .then(response => response.data)
}

const storeCustomer = (applicationId, credentials) => {
    return axios.post(`/applicant/applications/${applicationId}/customers/add`, credentials)
        .then(response => response.data)
}

const storeConfidant = (applicationId, credentials) => {
    return axios.post(`/applicant/applications/${applicationId}/confidant/add`, credentials)
        .then(response => response.data)
}

const updateConfidant = (applicationId, confidantId, credentials) => {
    return axios.post(`/applicant/applications/${applicationId}/confidant/${confidantId}/edit`, credentials)
        .then(response => response.data)
}

const storeProjectDeveloper = (applicationId, credentials) => {
    return axios.post(`/applicant/applications/${applicationId}/project-developer/add`, credentials)
        .then(response => response.data)
}

const storeProjectArchitect = (projectDeveloperId, credentials) => {
    return axios.post(`/applicant/applications/project-developer/${projectDeveloperId}/architect/add`, credentials)
        .then(response => response.data)
}

const storeProjectEngineer = (projectDeveloperId, credentials) => {
    return axios.post(`/applicant/applications/project-developer/${projectDeveloperId}/engineer/add`, credentials)
        .then(response => response.data)
}

const updateProjectArchitect = (projectDeveloperId, projectArchitectId, credentials) => {
    return axios.post(`/applicant/applications/project-developer/${projectDeveloperId}/architect/${projectArchitectId}/edit`, credentials)
        .then(response => response.data)
}

const updateProjectEngineer = (projectDeveloperId, projectEngineerId, credentials) => {
    return axios.post(`/applicant/applications/project-developer/${projectDeveloperId}/engineer/${projectEngineerId}/edit`, credentials)
        .then(response => response.data)
}

const storeDocument = (applicationId, credentials) => {
    return axios.post(`/applicant/applications/${applicationId}/documents/add`, credentials)
        .then(response => response.data)
}

const storeDocumentation = (applicationId, credentials) => {
    return axios.post(`/applicant/applications/${applicationId}/initial-permit-documentation/add`, credentials)
        .then(response => response.data)
}

const storeReceipt = (applicationId, paymentId, credentials) => {
    return axios.post(`/applicant/applications/${applicationId}/payment/${paymentId}`, credentials)
        .then(response => response.data)
}

const signPayment = (applicationId, paymentId, form) => {
    return axios.post(`/applicant/applications/${applicationId}/payment/${paymentId}/sign`, form)
        .then(response => response.data)
}

const storeCertifyingDocument = (applicationId, credentials) => {
    return axios.post(`/applicant/applications/${applicationId}/certifying-document/add`, credentials)
        .then(response => response.data)
}

const storeApplicantCertifyingDocument = (applicantId, credentials) => {
    return axios.post(`/applicant/applications/executor/${applicantId}/certifying-document/add`, credentials)
        .then(response => response.data)
}

const storeEconomicIndicator = (applicationId, credentials) => {
    return axios.post(`/applicant/applications/${applicationId}/economic-indicator/add`, credentials)
        .then(response => response.data)
}

const updateCustomer = (applicationId, customerId, credentials) => {
    return axios.post(`/applicant/applications/${applicationId}/customers/${customerId}/edit`, credentials)
        .then(response => response.data)
}

const updateProjectDeveloper = (applicationId, projectDeveloperId, credentials) => {
    return axios.post(`/applicant/applications/${applicationId}/project-developer/${projectDeveloperId}/edit`, credentials)
        .then(response => response.data)
}

const updateDocument = (applicationId, documentId, credentials) => {
    return axios.post(`/applicant/applications/${applicationId}/documents/${documentId}/edit`, credentials)
        .then(response => response.data)
}

const updateCertifyingDocument = (applicationId, docId, credentials) => {
    return axios.post(`/applicant/applications/${applicationId}/certifying-document/${docId}/edit`, credentials)
        .then(response => response.data)
}

const updateApplicantCertifyingDocument = (applicantId, docId, credentials) => {
    return axios.post(`/applicant/applications/executor/${applicantId}/certifying-document/${docId}/edit`, credentials)
        .then(response => response.data)
}

const updateEconomicIndicator = (applicationId, economicIndicatorId, credentials) => {
    return axios.post(`/applicant/applications/${applicationId}/economic-indicator/${economicIndicatorId}/edit`, credentials)
        .then(response => response.data)
}

const deleteCustomer = (applicationId, customerId) => {
    return axios.post(`/applicant/applications/${applicationId}/customers/${customerId}/delete`)
        .then(response => response.data)
}

const deleteProjectDeveloper = (applicationId, projectDeveloperId) => {
    return axios.delete(`/applicant/applications/${applicationId}/project-developer/${projectDeveloperId}/delete`)
        .then(response => response.data)
}

const deleteProjectArchitect = (projectDeveloperId, projectArchitectId) => {
    return axios.delete(`/applicant/applications/project-developer/${projectDeveloperId}/architect/${projectArchitectId}/delete`)
        .then(response => response.data)
}

const deleteProjectEngineer = (projectDeveloperId, projectEngineerId) => {
    return axios.delete(`/applicant/applications/project-developer/${projectDeveloperId}/engineer/${projectEngineerId}/delete`)
        .then(response => response.data)
}

const deleteDocument = (applicationId, documentId) => {
    return axios.post(`/applicant/applications/${applicationId}/documents/${documentId}/delete`)
        .then(response => response.data)
}

const deleteDocumentation = (applicationId, documentationId) => {
    return axios.post(`/applicant/applications/${applicationId}/initial-permit-documentations/${documentationId}/delete`)
        .then(response => response.data)
}

const deleteDocumentFile = (applicationId, documentFileId) => {
    return axios.post(`/applicant/applications/${applicationId}/documents/delete-file/${documentFileId}`)
        .then(response => response.data)
}

const deleteDocumentsVersionAdditionalFile = (applicationId, documentsVersionId, documentsVersionsAdditionalFileId) => {
    return axios.post(`/applicant/applications/${applicationId}/versions/${documentsVersionId}/delete-additional-file/${documentsVersionsAdditionalFileId}`)
        .then(response => response.data)
}

const deleteCertifyingDocument = (applicationId, docId) => {
    return axios.post(`/applicant/applications/${applicationId}/certifying-document/${docId}/delete`)
        .then(response => response.data)
}

const deleteApplicantCertifyingDocument = (applicantId, docId) => {
    return axios.post(`/applicant/applications/executor/${applicantId}/certifying-document/${docId}/delete`)
        .then(response => response.data)
}

const deleteConfidant = (applicationId, confidantId) => {
    return axios.delete(`/applicant/applications/${applicationId}/confidant/${confidantId}/delete`)
        .then(response => response.data)
}

const deleteEconomicIndicator = (applicationId, economicIndicatorId) => {
    return axios.post(`/applicant/applications/${applicationId}/economic-indicator/${economicIndicatorId}/delete`)
        .then(response => response.data)
}

const storePlanner = (id, credentials) => {
    return axios.post(`/applicant/applications/${id}/project-developer/add`, credentials)
        .then(response => response.data)
}

const updatePlanner = (id, credentials) => {
    return axios.post(`/applicant/applications/${id}/project-developer/edit`, credentials)
        .then(response => response.data)
}

const storeAgreement = (id, credentials) => {
    return axios.post(`/applicant/applications/${id}/agreement/add`, credentials)
        .then(response => response.data)
}

export const getAgreementFile = (applicationId, agreementId) => {
    return axios.get(`/applicant/applications/${applicationId}/agreement/${agreementId}/file`)
        .then(response => response.data)
}
export const getAppFile = (applicationId, fileId) => {
    return axios.get(`/applicant/applications/${applicationId}/app-file/${fileId}`)
        .then(response => response.data)
}
const getDocumentsVersionLetterFile = (applicationId, documentsVersionId) => {
    return axios.get(`/applicant/applications/${applicationId}/versions/${documentsVersionId}/letter-file`)
        .then(response => response.data)
}

const getDocumentsVersionAttachmentFile = (applicationId, documentsVersionId, fileId) => {
    return axios.get(`/applicant/applications/${applicationId}/versions/${documentsVersionId}/file/${fileId}`)
        .then(response => response.data)
}

const getInProcessRemarksFile = (applicationId, documentsVersionId, fileId) => {
    return axios.get(`/applicant/applications/${applicationId}/versions/${documentsVersionId}/in-process-remarks-file/${fileId}`)
        .then(response => response.data)
}

const getDocumentFile = (applicationId, documentId, documentFileId) => {
    return axios.get(`/applicant/applications/${applicationId}/documents/${documentId}/file/${documentFileId}`)
        .then(response => response.data)
}

const getDocumentationFile = (applicationId, documentationId) => {
    return axios.get(`/applicant/applications/${applicationId}/initial-permit-documentations/${documentationId}/file`)
        .then(response => response.data)
}

const getDocumentsVersionAdditionalFile = (applicationId, documentsVersionId, documentsVersionsAdditionalFileId) => {
    return axios.get(`/applicant/applications/${applicationId}/versions/${documentsVersionId}/additional-file/${documentsVersionsAdditionalFileId}`)
        .then(response => response.data)
}

const getProjectDeveloperFile = (applicationId, projectDeveloperId, fileId) => {
    return axios.get(`/applicant/applications/${applicationId}/project-developer/${projectDeveloperId}/file/${fileId}`)
        .then(response => response.data)
}

const getProjectArchitectFile = (projectDeveloperId, projectArchitectId) => {
    return axios.get(`/applicant/applications/project-developer/${projectDeveloperId}/architect/${projectArchitectId}/file`)
        .then(response => response.data)
}

const getProjectEngineerFile = (projectDeveloperId, projectEngineerId) => {
    return axios.get(`/applicant/applications/project-developer/${projectDeveloperId}/engineer/${projectEngineerId}/file`)
        .then(response => response.data)
}

const updateAgreement = (applicationId, agreementId, credentials) => {
    return axios.post(`/applicant/applications/${applicationId}/agreement/${agreementId}/edit`, credentials)
        .then(response => response.data)
}

const generateApplicationFile = (id, form) => {
    return axios.post(`/applicant/applications/${id}/generate-file`, form)
        .then(response => response.data)
}

const acceptCustomerRequest = (applicationId, customerId) => {
    return axios.post(`/applicant/applications/${applicationId}/customers/${customerId}/accept-request`)
        .then(response => response.data)
}

const acceptDeveloperRequest = (applicationId, developerId) => {
    return axios.post(`/applicant/applications/${applicationId}/project-developer/${developerId}/accept-request`)
        .then(response => response.data)
}

const refuseCustomerRequest = (applicationId, customerId) => {
    return axios.post(`/applicant/applications/${applicationId}/customers/${customerId}/accept-refuse`)
        .then(response => response.data)
}

const refuseDeveloperRequest = (applicationId, developerId) => {
    return axios.post(`/applicant/applications/${applicationId}/project-developer/${developerId}/refuse-request`)
        .then(response => response.data)
}

const reassignApplicant = (applicationId, credentials) => {
    return axios.post(`/applicant/applications/${applicationId}/applicant/re-assign`, credentials)
        .then(response => response.data)
}

const signAdditionalLetter = (applicationId, versionId, form) => {
    return axios.post(`/applicant/applications/${applicationId}/versions/${versionId}/additional-files/sign`, form)
        .then(response => response.data)
}

const signDocument = (applicationId, documentId, form) => {
    return axios.post(`/applicant/applications/${applicationId}/documents/${documentId}/sign`, form)
        .then(response => response.data)
}

const signAllDocuments = (applicationId, form) => {
    return axios.post(`/applicant/applications/${applicationId}/documents/sign-all`, form)
        .then(response => response.data)
}

const storeDocumentFiles = (applicationId, documentId, form) => {
    return axios.post(`/applicant/applications/${applicationId}/documents/${documentId}/add-file`, form)
        .then(response => response.data)
}

const storeDocumentsVersionFiles = (applicationId, versionId, form) => {
    return axios.post(`/applicant/applications/${applicationId}/versions/${versionId}/add-additional-files`, form)
        .then(response => response.data)
}

const signAgreement = (applicationId, agreementId, form) => {
    return axios.post(`/applicant/applications/${applicationId}/agreement/${agreementId}/sign`, form)
        .then(response => response.data)
}

const statusList = () => {
    return axios.get(`/applicant/applications/status/list`)
        .then(response => response.data)
}

const loadConfidantFile = (applicationId, confidantId) => {
    return axios.get(`/applicant/applications/${applicationId}/confidant/${confidantId}/file`)
        .then(response => response.data)
}

const setPayer = (applicationId, form) => {
    return axios.post(`/applicant/applications/${applicationId}/set-payer`, form)
        .then(response => response.data)
}

const findConclusionByNumber = (form) => {
    return axios.post(`/applicant/applications/conclusion/find-by-number`, form)
        .then(response => response.data)
}

export const loadAdditionalAgreements = (agreementId) => {
    return axios.get(`/applicant/applications/agreement/${agreementId}/additional-list`)
        .then(response => response.data)
}

export const attachAdditionalAgreement = (agreementId, form) => {
    return axios.post(`/applicant/applications/agreement/${agreementId}/new`, form)
        .then(response => response.data)
}

export const editAdditionalAgreement = (agreementId, additionalAgreementId, form) => {
    return axios.post(`/applicant/applications/agreement/${agreementId}/additional/${additionalAgreementId}/edit`, form)
        .then(response => response.data)
}

export const deleteAdditionalAgreement = (agreementId, additionalAgreementId) => {
    return axios.post(`/applicant/applications/agreement/${agreementId}/additional/${additionalAgreementId}/delete`)
        .then(response => response.data)
}

export const getAdditionalAgreementFile = (agreementId, additionalAgreementId) => {
    return axios.get(`/applicant/applications/agreement/${agreementId}/additional-agreement/${additionalAgreementId}/file`)
        .then(response => response.data)
}

export const getAdditionalAgreementBasisFile = (agreementId, additionalAgreementId) => {
    return axios.get(`/applicant/applications/agreement/${agreementId}/additional-agreement/${additionalAgreementId}/basis-file`)
        .then(response => response.data)
}

export const signAdditionalAgreement = (additionalAgreementId, form) => {
    return axios.post(`/applicant/applications/agreement/additional-agreement/${additionalAgreementId}/sign`, form)
        .then(response => response.data)
}

export const getCommentFile = (commentId, commentFileId) => {
    return axios.get(`/applicant/applications/comment/${commentId}/file/${commentFileId}`)
        .then(response => response.data)
}

export default {
    getInProcessRemarksFile,
    getApplications,
    getApplication,
    deleteApplication,
    sendToExpertise,
    storeApplication,
    storeRepeatedApplication,
    updateApplication,
    updateRepeatedApplication,
    storeLocation,
    updateLocation,
    storeCustomer,
    storeConfidant,
    updateConfidant,
    storeProjectDeveloper,
    storeProjectArchitect,
    storeProjectEngineer,
    updateProjectArchitect,
    updateProjectEngineer,
    updateCustomer,
    updateProjectDeveloper,
    deleteCustomer,
    deleteProjectDeveloper,
    deleteProjectArchitect,
    deleteProjectEngineer,
    storeCertifyingDocument,
    storeApplicantCertifyingDocument,
    storeEconomicIndicator,
    updateCertifyingDocument,
    updateApplicantCertifyingDocument,
    updateEconomicIndicator,
    deleteCertifyingDocument,
    deleteApplicantCertifyingDocument,
    deleteConfidant,
    deleteEconomicIndicator,
    storePlanner,
    updatePlanner,
    storeDocument,
    storeReceipt,
    signPayment,
    deleteDocument,
    deleteDocumentation,
    updateDocument,
    storeAgreement,
    getAgreementFile,
    updateAgreement,
    generateApplicationFile,
    acceptCustomerRequest,
    acceptDeveloperRequest,
    refuseCustomerRequest,
    refuseDeveloperRequest,
    reassignApplicant,
    signAdditionalLetter,
    signDocument,
    signAllDocuments,
    deleteDocumentFile,
    deleteDocumentsVersionAdditionalFile,
    storeDocumentFiles,
    storeDocumentsVersionFiles,
    signAgreement,
    getDocumentsVersionLetterFile,
    getDocumentsVersionAttachmentFile,
    getDocumentFile,
    getDocumentationFile,
    getDocumentsVersionAdditionalFile,
    getProjectDeveloperFile,
    getProjectArchitectFile,
    getProjectEngineerFile,
    sendRemarksToExpertise,
    statusList,
    loadConfidantFile,
    setPayer,
    findConclusionByNumber,
    loadAdditionalAgreements,
    attachAdditionalAgreement,
    editAdditionalAgreement,
    deleteAdditionalAgreement,
    getAdditionalAgreementFile,
    getAdditionalAgreementBasisFile,
    signAdditionalAgreement,
    getCommentFile,
    storeDocumentation,
    getAppFile,
    sendInProcessTypeRemarksToExpertise,
};
